var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447716 0.447715 0 1 0H41.8571C42.4094 0 42.8571 0.447715 42.8571 1V29C42.8571 29.5523 42.4094 30 41.8571 30H0.999999C0.447714 30 0 29.5523 0 29V1Z",
    fill: "#F1F2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7012 21.2102C30.0725 21.2102 30.3749 21.4935 30.3749 21.8353V23.0854H11.6248V21.8353C11.6248 21.4935 11.9274 21.2102 12.2985 21.2102H12.8748V20.6332C12.8748 20.2913 13.1774 20.0081 13.5485 20.0081L14.1249 20.0083V12.5395H13.5485C13.1772 12.5395 12.8748 12.2562 12.8748 11.9144H11.6248V10.6643L20.9999 6.91431L30.3751 10.6643V11.9144H29.125C29.125 12.2562 28.8224 12.5395 28.4513 12.5395H27.875V20.0083H28.4513C28.8227 20.0083 29.125 20.2916 29.125 20.6334V21.2102H29.7012ZM16.6249 12.5395V20.0083H17.875V12.5395H16.6249ZM20.3749 12.5395V20.0083H21.625V12.5395H20.3749ZM24.1249 12.5395V20.0083H25.375V12.5395H24.1249Z",
    fill: "#4079F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.8355b1dcd61d87f4124e58449fc7c565.svg";
export { ForwardRef as ReactComponent };